<template>
  <div>
    <div class="page-header">
      <div class="page-leftheader">
          <v-tabs v-model="PostTab">
            <v-tab href="#tab-1">
              <div class="page-leftheader">
                <div class="headline">
                  <h4 class="page-title text-primary">Alle Beiträge</h4>
                </div>
              </div>
            </v-tab>

            <v-tab href="#tab-2">
              <div class="page-leftheader">
                <div class="headline">
                  <h4 class="page-title text-primary">Bilder</h4>
                </div>
              </div>
            </v-tab>
          </v-tabs>
      </div>
      <div class="page-rightheader" style="display: inline-flex;">
        <div v-show="showSpecificDateFilter" style="display: inline-flex">
          <input type="date" class="form-control" placeholder="" v-model="timeFilter.fromTime">&nbsp;<span style="padding-top: .5em;">bis</span>&nbsp;<input type="date" class="form-control" placeholder="" v-model="timeFilter.toTime">
        </div>&nbsp;
        <a class="btn btn-primary btn-pill" style="float: right;" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fa fa-calendar me-2 fs-14"></i> Nach Datum filtern</a>
                    <div class="dropdown-menu border-0">
                            <a class="dropdown-item" v-bind:class="{'active': showSpecificDateFilter}" id="dropdownSpecific" @click="openFromTimeToTimePickers()">Konkreter Zeitraum</a>
                            <a class="dropdown-item" v-bind:class="{'active': currentTimeSpan == 'Today'}" id="dropdownToday" @click="setTimePicker('Today')">Letzte 24 Stunden</a>
                            <a class="dropdown-item" v-bind:class="{'active': currentTimeSpan == 'LastWeek'}" id="dropdownLastWeek" @click="setTimePicker('LastWeek')">Letzte 7 Tage</a>
                            <a class="dropdown-item" v-bind:class="{'active': currentTimeSpan == 'LastMonth'}" id="dropdownLastMonth" @click="setTimePicker('LastMonth')">Letzte 30 Tage</a>
                            <a class="dropdown-item" v-bind:class="{'active': currentTimeSpan == 'AllTime'}" id="dropdownAllTime" @click="setTimePicker('AllTime')">Gesamt</a>
                    </div>
      </div>
    </div>
    <v-tabs-items v-model="PostTab">
      <!-- TABLE TAB -->
      <v-tab-item :value="'tab-1'">
        <div>
          <div>
            <!-- WAR FALSCH: Die Suche kennt keinen Von-Bis-Zeitraum (die
                 Such-Route erlaubt nur eine grobe Stufe: 1/7/30 Tage oder
                 "Gesamt"). Beim Tippen wurde "Konkreter Zeitraum" bisher
                 stillschweigend verworfen und stattdessen über ALLE Beiträge
                 gesucht — der Verwalter bekam Treffer weit außerhalb des
                 eingestellten Zeitraums, ohne jeden Hinweis. Das Suchfeld ist
                 jetzt gesperrt, solange "Konkreter Zeitraum" aktiv ist, statt
                 ein falsches Ergebnis vorzutäuschen. -->
            <input
              v-model="search"
              type="search"
              class="form-control form-control-sm"
              placeholder="Suche..."
              aria-controls="example1"
              :disabled="showSpecificDateFilter"
            />
            <!-- WAR UNVOLLSTÄNDIG: Der Grund für das gesperrte Feld stand nur
                 im title-Attribut. Ein Sprechblasen-Hinweis setzt aber
                 voraus, dass das Feld Mauszeiger-Ereignisse annimmt — genau
                 die unterdrückt ein gesperrtes Eingabefeld. Der Verwalter sah
                 also ein ausgegrautes Suchfeld ohne jede Begründung und
                 musste es für einen Fehler halten. Der Hinweis steht deshalb
                 jetzt sichtbar daneben, und er sagt auch, wie man wieder
                 suchen kann. -->
            <small class="text-muted d-block mt-1" v-if="showSpecificDateFilter">
              Bei einem konkreten Zeitraum ist die Suche nicht möglich — die Suche des Servers
              kennt nur die groben Stufen (24 Stunden, 7 Tage, 30 Tage, Gesamt). Zum Suchen oben
              unter „Nach Datum filtern" eine dieser Stufen wählen.
            </small>
            <br />
          </div>
          <div>
            <div>
              <div class="card">
                <!--
                  FEHLER 3: War nur "posts.length === 0 ? Leermeldung : Tabelle".
                  Eine Ablehnung (HTTP 200, success:false) liess posts vorher auf
                  undefined stehen — [].length gab es nicht mehr her, das warf
                  beim Zeichnen und liess die Seite weiß werden (siehe
                  fetchPosts/searchPost). postsError geht jetzt vor und macht
                  eine Ablehnung von echter Leere unterscheidbar.
                -->
                <div class="card-body text-center text-danger" v-if="postsError">
                  {{ postsError }}
                </div>
                <div class="card-body text-center text-muted" v-else-if="posts.length === 0">
                  Keine Beiträge im gewählten Zeitraum.
                </div>
                <div class="table-responsive" v-else>
                  <table class="table card-table table-vcenter">
                    <thead>
                      <tr>
                        <th>Beitrag</th>
                        <th>Verfasser</th>
                        <th>Ort</th>
                        <th class="text-center">Gefällt</th>
                        <th class="text-center">Kommentare</th>
                        <th>Datum</th>
                        <th class="text-right">Aktion</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="post in posts" :key="post._id">
                        <!--
                          Vorschau eckig und deutlich größer als der frühere
                          40px-Kreis — auf einem runden Ausschnitt war vom
                          Bildinhalt praktisch nichts zu erkennen.
                        -->
                        <td class="align-middle">
                          <div class="post-cell">
                            <div class="post-preview" @click="openEditPost(post)">
                              <img
                                v-if="firstImage(post)"
                                :src="`${$img(firstImage(post), $awsSmallImages)}`"
                                alt=""
                                class="post-preview-image"
                                @error="handleImageError"
                              />
                              <div class="post-preview-empty" v-else>
                                <i class="fe fe-image"></i>
                              </div>
                              <span class="post-image-count" v-if="imageCount(post) > 1">
                                {{ imageCount(post) }}
                              </span>
                            </div>
                            <span class="post-description" :title="post.description">
                              {{ post.description }}
                            </span>
                          </div>
                        </td>
                        <td class="align-middle">
                          <div class="post-author">
                            <img
                              :src="`${$img(post.user ? post.user.image : '', $awsSmallImages)}`"
                              alt=""
                              class="avatar avatar-sm brround mr-2"
                              @error="handleImageError"
                            />
                            <span>{{ post.user ? post.user.userName : 'Unbekannt' }}</span>
                          </div>
                        </td>
                        <td class="align-middle text-muted">{{ placeOf(post) }}</td>
                        <td class="align-middle text-center">{{ post.likes ? post.likes.count : 0 }}</td>
                        <td class="align-middle text-center">{{ post.commentsCount || 0 }}</td>
                        <td class="align-middle">{{$formatDate(post.createdAt)}}</td>
                        <td class="align-middle text-right post-actions">
                          <a
                            class="btn btn-primary btn-small mr-1"
                            title="Beitrag ansehen"
                            @click="openEditPost(post)"
                            ><i class="fas fa-expand"></i
                          ></a>
                          <a
                            class="btn btn-small btn-danger"
                            title="Beitrag löschen"
                            @click="openDeletePost(post)"
                            ><i class="fas fa-trash-alt"></i
                          ></a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>
              <div style="position:absolute; bottom: 500px;left:50%;height:40px;width:40px " v-intersect.quiet="infiniteScrolling"></div>
            </div>
          </div>
        </div>
      </v-tab-item>

      <!-- IMAGE TAB -->
      <v-tab-item :value="'tab-2'">
        <div>
          <div>
            <!-- WAR FALSCH: Die Suche kennt keinen Von-Bis-Zeitraum (die
                 Such-Route erlaubt nur eine grobe Stufe: 1/7/30 Tage oder
                 "Gesamt"). Beim Tippen wurde "Konkreter Zeitraum" bisher
                 stillschweigend verworfen und stattdessen über ALLE Beiträge
                 gesucht — der Verwalter bekam Treffer weit außerhalb des
                 eingestellten Zeitraums, ohne jeden Hinweis. Das Suchfeld ist
                 jetzt gesperrt, solange "Konkreter Zeitraum" aktiv ist, statt
                 ein falsches Ergebnis vorzutäuschen. -->
            <input
              v-model="search"
              type="search"
              class="form-control form-control-sm"
              placeholder="Suche..."
              aria-controls="example1"
              :disabled="showSpecificDateFilter"
            />
            <!-- WAR UNVOLLSTÄNDIG: Der Grund für das gesperrte Feld stand nur
                 im title-Attribut. Ein Sprechblasen-Hinweis setzt aber
                 voraus, dass das Feld Mauszeiger-Ereignisse annimmt — genau
                 die unterdrückt ein gesperrtes Eingabefeld. Der Verwalter sah
                 also ein ausgegrautes Suchfeld ohne jede Begründung und
                 musste es für einen Fehler halten. Der Hinweis steht deshalb
                 jetzt sichtbar daneben, und er sagt auch, wie man wieder
                 suchen kann. -->
            <small class="text-muted d-block mt-1" v-if="showSpecificDateFilter">
              Bei einem konkreten Zeitraum ist die Suche nicht möglich — die Suche des Servers
              kennt nur die groben Stufen (24 Stunden, 7 Tage, 30 Tage, Gesamt). Zum Suchen oben
              unter „Nach Datum filtern" eine dieser Stufen wählen.
            </small>
            <br />
          </div>
          <div>
            <div>
              <div class="card">
                <!-- Gleiche Absicherung wie im Reiter "Alle Beiträge": postsError
                     geht vor der Leermeldung, sonst wäre eine Ablehnung nicht
                     von echter Leere zu unterscheiden. -->
                <div class="card-body text-center text-danger" v-if="postsError">
                  {{ postsError }}
                </div>
                <div class="card-body text-center text-muted" v-else-if="postsWithImages.length === 0">
                  Keine Bilder im gewählten Zeitraum.
                </div>
                <!--
                  Gleichmäßiges Raster statt fester zwei Spalten: Die Kacheln
                  richten sich nach der Fensterbreite und haben alle dieselbe
                  Höhe. Zuvor standen die Bilder in Originalgröße nebeneinander
                  und liefen aus ihrer Spalte heraus.
                -->
                <div class="image-grid" v-else>
                  <div
                    class="image-tile"
                    v-for="post in postsWithImages"
                    :key="post._id"
                    @click="openGallery(post)"
                  >
                    <img
                      v-if="firstImage(post)"
                      :src="`${$img(firstImage(post), $awsLargeImages)}`"
                      alt=""
                      loading="lazy"
                      @error="handleImageError"
                    />
                    <div class="image-tile-empty" v-else>
                      <i class="fe fe-image"></i>
                    </div>

                    <span class="post-image-count" v-if="imageCount(post) > 1">
                      {{ imageCount(post) }}
                    </span>

                    <!-- Angaben zum Beitrag erscheinen erst beim Überfahren,
                         damit das Raster ruhig bleibt -->
                    <div class="image-tile-info">
                      <span class="image-tile-author">
                        {{ post.user ? post.user.userName : 'Unbekannt' }}
                      </span>
                      <span class="image-tile-stats">
                        <i class="fe fe-heart"></i> {{ post.likes ? post.likes.count : 0 }}
                        <i class="fe fe-message-circle ml-2"></i> {{ post.commentsCount || 0 }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div style="position:absolute; bottom: 500px;left:50%;height:40px;width:40px " v-intersect.quiet="infiniteScrolling"></div>
            </div>
          </div>
        </div>

      </v-tab-item>
    </v-tabs-items>

    <!--
      Beide Dialoge standen zweimal im Vorlagentext — einmal je Reiter, beide an
      dieselbe Variable gebunden. Vuetify behält einen einmal geöffneten
      v-tab-item im DOM, deshalb öffneten sich nach einem Besuch beider Reiter
      zwei gleiche Dialoge übereinander. Jetzt stehen sie einmal außerhalb der
      Reiter.
    -->
    <v-dialog v-model="editDialog" width="500">
      <v-card>
        <v-card-title class="card">
          <h4 class="page-title text-primary">Beitrag anschauen</h4>
        </v-card-title>
        <v-card-text>
          <div class="form-group">
            <label class="form-label">Benutzername</label>
            <!-- WAR FALSCH: Hier stand v-model="editPost.user.userName" ohne
                 jede Absicherung. Beiträge, deren Verfasser gelöscht oder
                 gesperrt ist, kommen ohne das Feld "user" an — die Tabelle
                 rechnet auch damit ("post.user ? ... : 'Unbekannt'"), dieser
                 Dialog aber nicht. FOLGE (nachgestellt): Der Verwalter klickt
                 bei einem solchen Beitrag auf "Beitrag ansehen" und es
                 passiert schlicht gar nichts — die Anzeige des Dialogs bricht
                 beim Aufbau ab, der Fehler landet nur in der
                 Browser-Konsole. Ausgerechnet die auffälligen Beiträge lassen
                 sich damit nicht öffnen.
                 Das Feld ist ohnehin gesperrt (disabled), es zeigt nur an und
                 schreibt nichts zurück — deshalb :value statt v-model, mit
                 derselben Ersatzbeschriftung wie in der Tabelle. -->
            <input
              type="text"
              class="form-control"
              placeholder=""
              :value="editPost.user ? editPost.user.userName : 'Unbekannt'"
              disabled
            />
          </div>
          <div class="form-group">
            <label class="form-label">Beschreibung</label>
            <textarea
              rows="4"
              class="form-control"
              placeholder=""
              v-model="editPost.description"
              disabled
            ></textarea>
          </div>
          <div class="form-group">
            <label class="form-label">Datum</label>
            <input
              type="date"
              class="form-control"
              placeholder=""
              v-model="editPost.dateObject"
              disabled
            />
          </div>
          <div class="form-group">
            <label class="form-label">Uhrzeit</label>
            <input
              type="time"
              class="form-control"
              placeholder=""
              v-model="editPost.timeObject"
              disabled
            />
          </div>
          <div class="form-group">
            <label class="form-label">Adresse</label>
            <GoogleMap
              v-model="editPost.addressObject" :disabled="true"
            />
          </div>
          <div class="form-group">
            <label class="form-label">Bilder</label>
            <v-carousel>
              <v-carousel-item
                v-for="(item,i) in editPost.galleryImages"
                :key="i"
                :src="`${$img(item.url,$awsLargeImages)}`"
                reverse-transition="fade-transition"
                transition="fade-transition"
              ></v-carousel-item>
            </v-carousel>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <a
            class="btn btn-primary btn-pill mr-1"
            @click="editDialog = false"
            >Schließen</a
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" width="500">
      <v-card>
        <v-card-title class="card">
          <h4 class="page-title text-primary">Beitrag löschen</h4>
        </v-card-title>
        <v-card-text>
          Sind Sie sicher, dass Sie diesen Beitrag löschen wollen?
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <a
            class="btn btn-primary btn-pill mr-1"
            @click="deleteDialog = false"
            >Abbrechen</a
          >
          <a class="btn btn-danger btn-pill" @click="deletePost(editPost)"
            >Löschen</a
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!--
      Großansicht für das Bilderraster: zeigt alle Bilder eines Beitrags,
      lässt blättern und über die Pfeiltasten wechseln.
    -->
    <v-dialog v-model="galleryDialog" max-width="1000" content-class="gallery-dialog">
      <div class="gallery-view" v-if="galleryPost">
        <div class="gallery-head">
          <div class="gallery-author">
            <img
              :src="`${$img(galleryPost.user ? galleryPost.user.image : '', $awsSmallImages)}`"
              alt=""
              class="avatar avatar-sm brround mr-2"
              @error="handleImageError"
            />
            <div>
              <div>{{ galleryPost.user ? galleryPost.user.userName : 'Unbekannt' }}</div>
              <small class="text-muted">
                {{ $formatDate(galleryPost.createdAt) }}
                <span v-if="placeOf(galleryPost) !== '—'">&middot; {{ placeOf(galleryPost) }}</span>
              </small>
            </div>
          </div>
          <a class="gallery-close" @click="galleryDialog = false" title="Schließen">
            <i class="fe fe-x"></i>
          </a>
        </div>

        <div class="gallery-stage">
          <a
            class="gallery-arrow gallery-arrow-left"
            v-if="galleryImages.length > 1"
            @click="showPreviousImage()"
            title="Vorheriges Bild"
          >
            <i class="fe fe-chevron-left"></i>
          </a>

          <img
            v-if="galleryImages.length > 0"
            :src="`${$img(galleryImages[galleryIndex].url, $awsLargeImages)}`"
            alt=""
            class="gallery-image"
            @error="handleImageError"
          />

          <a
            class="gallery-arrow gallery-arrow-right"
            v-if="galleryImages.length > 1"
            @click="showNextImage()"
            title="Nächstes Bild"
          >
            <i class="fe fe-chevron-right"></i>
          </a>
        </div>

        <div class="gallery-foot">
          <div class="gallery-text">{{ galleryPost.description }}</div>
          <div class="gallery-meta">
            <span><i class="fe fe-heart"></i> {{ galleryPost.likes ? galleryPost.likes.count : 0 }}</span>
            <span class="ml-3"><i class="fe fe-message-circle"></i> {{ galleryPost.commentsCount || 0 }}</span>
            <span class="ml-3" v-if="galleryImages.length > 1">
              Bild {{ galleryIndex + 1 }} von {{ galleryImages.length }}
            </span>
          </div>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import GoogleMap from "./widget/GoogleMap.vue";

export default {
  components: {},

  data() {
    return {
      page: 0,
      totalPages: 1,
      ElementPerPage: 25,
      sort: null,
      search: "",
      PostTab:null,

      showSpecificDateFilter: false,
      timeFilter: {
        fromTime: null,
        toTime: null,
      },

      // Großansicht im Bilderraster
      galleryDialog: false,
      galleryPost: null,
      galleryIndex: 0,

      // Personal Data
      me: null,

      posts: [],
      // Trennt "wirklich leer" von "Abruf gescheitert" — siehe
      // fetchPosts()/searchPost() und die Zustandskette im Template (FEHLER 3).
      postsError: '',
      editPost: {
          _id: '',
          address: {
              location: {
                  coordinates: [],
              }
          },
          user: {},
          galleryImages: [],
          createdAt: '',
          description: '',
      },

      editDialog: false,
      deleteDialog: false,
      emptyDialog: false,
      emptyValidation: false,
      currentTimeSpan: 'LastMonth'
    };
  },

  name: "App",
  components: {
    GoogleMap,
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    search: function () {
      if (this.search == "") {
        this.fetchPosts();
      } else {
        this.page = 0;
        this.searchPost();
      }
    },
    editDialog: function () {
       if(this.editDialog == false) {
         this.emptyValidation = false;
         this.$forceUpdate();
       }
    },
    // WAR FALSCH: Der eingetippte Wert lief hier ungeprüft weiter. Vertippte
    // sich der Verwalter im Jahr (z.B. "99999" statt "2026" — ein
    // Datumsfeld im Browser lässt das zu), lief die Umrechnung des
    // Bis-Datums in einen Fehler und der Abruf brach ab, bevor überhaupt
    // eine Anfrage abging. Die Tabelle blieb wortlos auf dem alten Stand,
    // der Verwalter hielt das für das Filterergebnis. Jetzt bekommt er einen
    // Hinweis, statt mit einem unbrauchbaren Zeitraum weiterzuarbeiten.
    "timeFilter.fromTime": function(val){
      if(val != null){
        if(!this.hasUsableTimeFilter()){
          this.$noty.error('Der eingegebene Zeitraum enthält kein gültiges Datum. Bitte Von- und Bis-Datum prüfen (besonders die Jahreszahl).');
          return;
        }
        this.fetchPosts();
      }
    },
    "timeFilter.toTime": function(val){
      if(val != null){
        if(!this.hasUsableTimeFilter()){
          this.$noty.error('Der eingegebene Zeitraum enthält kein gültiges Datum. Bitte Von- und Bis-Datum prüfen (besonders die Jahreszahl).');
          return;
        }
        this.fetchPosts();
      }
    }
  },

  mounted() {
    this.fetchPosts();
    if(this.$route.params.post) {
      this.openEditPost(this.$route.params.post, 'edit');
    }
    this.$root.$on('Posts', (post) => {
      this.openEditPost(post, 'edit');
    })
    window.addEventListener('keydown', this.handleGalleryKeys);
  },

  beforeDestroy() {
    window.removeEventListener('keydown', this.handleGalleryKeys);
  },

  computed: {
    /** Bilder des gerade geöffneten Beitrags. */
    galleryImages() {
      if (!this.galleryPost || !this.galleryPost.galleryImages) return [];
      return this.galleryPost.galleryImages;
    },

    // WAR FALSCH: Der Reiter "Bilder" lief bisher über ALLE Beiträge (posts)
    // und stellte für jeden ohne Bild einen Platzhalter dar — reine
    // Textbeiträge sahen dadurch wie kaputte Bilder aus (auf Seite 1 waren
    // es 15 von 23 Kacheln). Der Reiter ist als Bildübersicht gedacht, hier
    // gehören also nur Beiträge hinein, die tatsächlich ein Bild haben.
    postsWithImages() {
      return this.posts.filter((post) => this.firstImage(post));
    },
  },

  methods: {
    /**
     * Erstes Bild eines Beitrags — mit Absicherung, weil ein Beitrag auch ohne
     * Bild vorliegen kann und der direkte Zugriff auf das erste Element dann
     * die ganze Tabelle zum Absturz brächte.
     */
    firstImage(post) {
      if (!post || !post.galleryImages || post.galleryImages.length === 0) return null;
      return post.galleryImages[0].url;
    },

    imageCount(post) {
      if (!post || !post.galleryImages) return 0;
      return post.galleryImages.length;
    },

    /** Ort eines Beitrags, sofern hinterlegt. */
    placeOf(post) {
      if (!post || !post.address) return '—';
      return post.address.city || post.address.place || '—';
    },

    openGallery(post) {
      this.galleryPost = post;
      this.galleryIndex = 0;
      this.galleryDialog = true;
    },

    showNextImage() {
      if (this.galleryImages.length === 0) return;
      this.galleryIndex = (this.galleryIndex + 1) % this.galleryImages.length;
    },

    showPreviousImage() {
      if (this.galleryImages.length === 0) return;
      this.galleryIndex =
        (this.galleryIndex - 1 + this.galleryImages.length) % this.galleryImages.length;
    },

    /** Blättern per Pfeiltasten, solange die Großansicht offen ist. */
    handleGalleryKeys(event) {
      if (!this.galleryDialog) return;
      if (event.key === 'ArrowRight') this.showNextImage();
      if (event.key === 'ArrowLeft') this.showPreviousImage();
    },

    infiniteScrolling(entries, observer, isIntersecting) {
        if(isIntersecting){
            setTimeout(() => {
                var _this = this;
                // WAR FALSCH: Es wurde nur weiter nachgeladen, wenn die letzte
                // Seite GENAU ElementPerPage Einträge lieferte. Die
                // Datenbankabfrage schneidet aber erst die Seite heraus und
                // blendet danach Beiträge blockierter/gesperrter/gelöschter
                // Verfasser aus — eine Seite mit weniger als ElementPerPage
                // Einträgen bedeutete also nicht zwangsläufig "Ende der
                // Liste". FOLGE (gemessen): Das Nachladen blieb dauerhaft
                // stehen, obwohl auf den nächsten Seiten noch Beiträge lagen.
                // Jetzt wird weitergeladen, solange die letzte Anfrage
                // überhaupt etwas geliefert hat.
                if(this.lastPosts > 0 || this.lastPosts == null){
                  console.log(this.page);
                  if(this.search ==  "" || this.search == null){
                    this.page++;
                    this.$axios
                          .post('/post/all/' + this.page * this.ElementPerPage + '/' + this.ElementPerPage + '/time', {
                            time: this.getCurrentTimeSpan(),
                            fromTime: this.timeFilter.fromTime,
                            toTime: this.getAdjustedToTime()
                          })
                          .then(function (response){
                            // WAR FALSCH: Eine Ablehnung (HTTP 200,
                            // success:false) sah bisher genauso aus wie "die
                            // Liste ist zu Ende" — data fehlt dann, .length
                            // griff auf undefined zu und warf; der Fehler
                            // landete im .catch, das Nachladen blieb stumm.
                            if (response.data != null && response.data.success === false) {
                              _this.lastPosts = 0;
                              _this.onError(response.data);
                              return;
                            }
                            _this.lastPosts = response.data.data.length;
                            if(response.data.data.length >= 1) {
                              response.data.data.forEach(item => _this.posts.push(item));
                            }
                          })
                          .catch(function (error) {
                            _this.lastPosts = 0;
                            _this.onError(error);
                          });
                  }
                  else{
                    this.page++;
                    // Ohne encodeURIComponent zerlegte ein Suchbegriff mit "/"
                    // oder "?" den Pfad — die Anfrage lief in einen 404.
                    this.$axios.get('/post/search/' + encodeURIComponent(this.search) +'/'+ this.page * this.ElementPerPage + '/' + this.ElementPerPage + '/' + this.getCurrentTimeSpan()).then(function(response){
                      if (response.data != null && response.data.success === false) {
                        _this.lastPosts = 0;
                        _this.onError(response.data);
                        return;
                      }
                      _this.lastPosts = response.data.data.length;
                      if(response.data.data.length >= 1) {
                        response.data.data.forEach(item => _this.posts.push(item));
                      }
                    }).catch(function(error){
                      _this.lastPosts = 0;
                      _this.onError(error);
                    });
                  }
                }
            }, 500);
        }
    },
    fetchPosts() {
      var _this = this;
      // Der Zähler blieb beim Neuladen stehen: Wer vorher gescrollt hatte,
      // sprang beim nächsten Nachladen mitten in die Liste und übersprang alles
      // dazwischen. Betrifft alle Aufrufer — geleerte Suche, Zeitraumwechsel
      // und die beiden Watcher auf timeFilter.
      this.page = 0;
      this.postsError = '';
      this.$axios
        .post("/post/all/0/" + this.ElementPerPage + '/time', {
          time: this.getCurrentTimeSpan(),
          fromTime: this.timeFilter.fromTime,
          toTime: this.getAdjustedToTime()
        })
        .then(function (response) {
          // WAR FALSCH (FEHLER 3): response.data.data wurde ungeprüft in posts
          // und dessen .length in lastPosts geschrieben. Bei einer Ablehnung
          // (HTTP 200, success:false) fehlt data — posts wurde erst auf
          // undefined gesetzt, dann warf der .length-Zugriff MITTEN IM
          // ERFOLGSZWEIG. Der Fehler landete im .catch, aber posts blieb auf
          // undefined stehen: Die Tabelle griff beim nächsten Zeichnen auf
          // undefined.length zu und die Seite wurde weiß. Jetzt bleibt die
          // zuletzt geladene Liste unverändert, postsError zeigt die
          // Servermeldung.
          if (response.data == null || response.data.success === false) {
            _this.postsError = _this.failureMessage(response.data) || 'Der Server hat die Anfrage abgelehnt.';
            _this.lastPosts = 0;
            _this.onError(response.data);
            return;
          }
          _this.posts = response.data.data;
          _this.lastPosts = response.data.data.length;
        })
        .catch(function (error) {
          _this.postsError = _this.failureMessage(error) || 'Die Anfrage ist fehlgeschlagen.';
          _this.lastPosts = 0;
          _this.onError(error);
        });
    },
    searchPost() {
      var _this = this;
      this.postsError = '';
      this.$axios
        .get(
          // Ohne encodeURIComponent zerlegte ein Suchbegriff mit "/" oder "?"
          // den Pfad — die Anfrage traf dann keine Route mehr (404).
          "/post/search/" +
            encodeURIComponent(this.search) +
            "/" +
            this.page +
            "/" +
            this.ElementPerPage
            + '/' + this.getCurrentTimeSpan()
        )
        .then(function (response) {
          // Gleiche Absicherung wie in fetchPosts: Ohne sie warf der
          // .length-Zugriff im Erfolgszweig, sobald der Server ablehnte, und
          // posts blieb auf undefined stehen.
          if (response.data == null || response.data.success === false) {
            _this.postsError = _this.failureMessage(response.data) || 'Der Server hat die Anfrage abgelehnt.';
            _this.lastPosts = 0;
            _this.onError(response.data);
            return;
          }
          _this.posts = response.data.data;
          _this.lastPosts = _this.posts.length;
        })
        .catch(function (error) {
          _this.postsError = _this.failureMessage(error) || 'Die Anfrage ist fehlgeschlagen.';
          _this.lastPosts = 0;
          _this.onError(error);
        });
    },
    // Das Nachladen hängte .catch(this.onError) an, die Methode gab es aber
    // nicht: .catch(undefined) reicht den Fehler durch und er landete als
    // unbehandelte Promise-Ablehnung — Fehler beim Scrollen blieben unsichtbar.
    //
    // WAR FALSCH (FEHLER 3/7): Der Behandler schrieb nur in die
    // Entwicklerkonsole, die niemand offen hat. Zwei Formen kommen vor:
    // Axios-Fehler (Netz/HTTP) und der Antwortkörper eines fachlichen
    // Fehlschlags ({success:false, message:"…"} mit HTTP 200), den die
    // Aufrufer unten direkt hereinreichen. Gleiches Muster wie in
    // Users.vue/Reported.vue.
    onError(err) {
      if (err != null && err.response != null && err.response.data != null) {
        console.error(err.response.data);
      } else {
        console.error(err);
      }
      const status = err != null && err.response != null ? err.response.status : null;
      if (status === 401 || status === 403) return;
      this.$noty.error(this.failureMessage(err) || 'Die Anfrage ist fehlgeschlagen.');
    },
    // Liefert AUSSCHLIESSLICH den Klartext, den der Server geschickt hat —
    // sonst null. Gleiches Muster wie in Users.vue/Reported.vue.
    failureMessage(err) {
      if (err == null) return null;
      if (err.response != null && err.response.data != null && err.response.data.message) {
        return err.response.data.message;
      }
      if (err.response == null && err.success === false && err.message) {
        return err.message;
      }
      return null;
    },
    // Fängt eine kaputte Bildadresse ab (Datei im Bildspeicher gelöscht,
    // Upload nur halb durchgelaufen). Ohne diesen Rückfall zeigte der
    // Browser nur das zerbrochene Bildsymbol.
    // WAR FALSCH (zweimal): Zuerst setzte die Bremse "event.target.onerror =
    // null" — das löscht nur die alte HTML-Eigenschaft onerror, die hier nie
    // benutzt wird. Die Vorlage meldet den Rückfall über "@error", Vue
    // registriert das intern per addEventListener; dieser Zuhörer blieb
    // aktiv, setzte bei einem scheiternden Ersatzbild erneut dieselbe
    // Adresse und drehte sich damit endlos im Kreis. Der zweite Anlauf
    // merkte sich den Rückfall dauerhaft am Bild-Element selbst
    // ("data-fallback-used"). Das bremste zwar die Schleife, galt aber für
    // IMMER: Die Zeilen und Kacheln haben einen festen Schlüssel (:key), Vue
    // verwendet dasselbe Bild-Element über jedes Neuladen der Liste hinweg
    // weiter. Kam danach ein neues, ebenfalls kaputtes Bild an dieselbe
    // Stelle, bekam sie keinen Rückfall mehr und zeigte wieder das
    // zerbrochene Bildsymbol des Browsers. Jetzt wird nicht mehr gemerkt
    // "Rückfall schon einmal benutzt", sondern geprüft, ob die AKTUELLE
    // Adresse bereits das Ersatzbild ist — das bremst genau die echte
    // Schleife (das Ersatzbild scheitert selbst) und lässt jedes neue Bild
    // wieder zu.
    handleImageError(event) {
      const fallbackImage = '/images/brand/favicon.png';
      if (event.target.getAttribute('src') === fallbackImage) return;
      event.target.src = fallbackImage;
    },
    openEditPost(post) {
        this.editPost = post;
        this.editPost.dateObject = post.createdAt.substring(
          0,
          post.createdAt.indexOf("T")
        );
        this.editPost.timeObject = post.createdAt.substring(
          post.createdAt.indexOf("T")+1,
          post.createdAt.length-8
        );

        // Für die Karte eine eigene, gedrehte Kopie der Koordinaten anlegen.
        // In der Datenbank stehen Koordinaten als [Länge, Breite], GoogleMap.vue
        // liest coordinates[0] aber als Breite und coordinates[1] als Länge
        // (siehe deren initFromValue()) — ungedreht zeigte die Karte auf den
        // falschen Ort auf der Erde (aus 52,16° Nord/13,48° Ost wurde 13,48°
        // Nord/52,16° Ost, Arabisches Meer statt Wünsdorf). Gleiches Vorgehen
        // wie openEditEvent() in Events.vue und openEditTrip() in Trips.vue.
        //
        // Die Karte ist hier :disabled="true" — es gibt keinen Speicherpfad,
        // der diese gedrehte Kopie zurückschreiben könnte, also keine Gefahr
        // eines doppelten Drehens.
        if (post.address && post.address.location && post.address.location.coordinates) {
          this.editPost.addressObject = Object.assign({}, post.address, {
            location: Object.assign({}, post.address.location, {
              coordinates: this.swapCoordinates(post.address.location.coordinates),
            }),
          });
        } else {
          this.editPost.addressObject = null;
        }

        this.editDialog = true;
    },
    // Vertauscht die Reihenfolge eines Koordinatenpaars. Gleiche Umsetzung
    // wie swapCoordinates() in Events.vue und Trips.vue.
    swapCoordinates(coordinates) {
      return [coordinates[1], coordinates[0]];
    },
    openDeletePost(post) {
        this.editPost = post;
        this.deleteDialog = true;
    },
    deletePost() {
      let _this = this;
        this.$axios
        .delete("/post/delete/" + this.editPost._id)
        .then(function (response) {
          console.log(response.data);
          // WAR FALSCH: Die Antwort wurde nicht auf "success" geprüft. Bei
          // einem bereits gelöschten oder nicht mehr vorhandenen Beitrag
          // (zweiter Klick, zweiter Verwalter, alter Reiter) antwortet das
          // Backend mit success:false, aber weiterhin Statuscode 200 — der
          // Dialog schloss sich trotzdem und die Liste lud "erfolgreich"
          // neu, obwohl nichts gelöscht wurde.
          // WAR FALSCH (FEHLER 7): success wurde zwar geprüft, gezeigt wurde
          // dann aber $showCommonError() ("Etwas ist schief gelaufen") statt
          // der eigentlichen Servermeldung — genau die Angabe, die sagt,
          // WARUM das Löschen abgelehnt wurde, ging verloren. Gleicher Stil
          // wie in Users.vue/Reported.vue: die Servermeldung selbst zeigen.
          if (response.data && response.data.success === false) {
            _this.onError(response.data);
            return;
          }
          _this.deleteDialog = false;
          // Hier stand this.fetchTrip(): Die Methode gibt es auf dieser Seite
          // nicht, und "this" zeigt in dieser Rückruffunktion ohnehin nicht auf
          // die Komponente. Die Zeile warf einen TypeError, die Liste blieb
          // stehen und der gelöschte Beitrag war weiter zu sehen.
          _this.fetchPosts();
        })
        .catch(function (error) {
          _this.onError(error);
        });

    },
    openFromTimeToTimePickers(){
      this.showSpecificDateFilter = true;
      this.currentTimeSpan = null;
      // Eine noch eingetragene Suche würde sonst weiter über die Route mit
      // der groben Zeitstufe laufen und damit den gerade gewählten
      // Zeitraum wieder verwerfen (siehe Sperre am Suchfeld oben in der
      // Vorlage).
      this.search = "";
    },
    // WAR FALSCH: Das Datumsfeld liefert nur den Tag ("2026-08-14"). Das
    // Backend vergleicht mit $lte gegen Mitternacht dieses Tages — alles,
    // was im Lauf des gewählten Endtags entstand, lag danach und fiel aus
    // dem Ergebnis heraus. Für den Server wird deshalb der FOLGETag als
    // Obergrenze verschickt, damit der gewählte Endtag vollständig
    // eingeschlossen ist. Das Eingabefeld selbst (timeFilter.toTime) bleibt
    // unverändert, nur der an den Server geschickte Wert wird verschoben.
    getAdjustedToTime() {
      if (!this.timeFilter.toTime) return this.timeFilter.toTime;
      // WAR FALSCH: Hier wurde ohne Prüfung gerechnet. Ein Datumsfeld im
      // Browser nimmt auch ein fünf- oder sechsstelliges Jahr an ("99999",
      // wenn im Jahresfeld eine Ziffer zuviel landet). Daraus entsteht kein
      // brauchbares Datum, und toISOString() brach dann mit einem Fehler ab
      // — mitten im Beobachter auf das Feld, also NOCH BEVOR überhaupt eine
      // Anfrage abging. Vue schrieb den Fehler nur in die Browser-Konsole:
      // Nach außen sah es aus, als hätte der Filter einfach nichts bewirkt,
      // die Tabelle zeigte weiter die alten Beiträge, ohne jede Meldung.
      // Jetzt bricht hier nichts mehr ab; ein unbrauchbarer Wert wird wie
      // "keine Obergrenze" behandelt. Damit das nicht stillschweigend
      // passiert, prüfen die Beobachter auf die beiden Datumsfelder den Wert
      // schon vorher und weisen den Verwalter darauf hin (siehe
      // hasUsableTimeFilter()).
      if (!this.isUsableFilterDate(this.timeFilter.toTime)) return null;
      const nextDay = new Date(this.timeFilter.toTime + 'T00:00:00.000Z');
      nextDay.setUTCDate(nextDay.getUTCDate() + 1);
      return nextDay.toISOString().substring(0, 10);
    },
    // Ergibt der Feldwert (JJJJ-MM-TT) ein brauchbares Datum? Ein Jahr mit
    // fünf oder sechs Ziffern lässt das Eingabefeld zwar zu, JavaScript kann
    // daraus aber kein Datum bilden.
    isUsableFilterDate(value) {
      if (!value) return true;
      return !isNaN(new Date(value + 'T00:00:00.000Z').getTime());
    },
    // Sind BEIDE Felder des konkreten Zeitraums brauchbar? Auch das
    // Von-Datum muss geprüft werden: Es wird unverändert an den Server
    // geschickt, der einen unbrauchbaren Wert behandelt, als wäre das Feld
    // gar nicht gesetzt — der Verwalter bekäme also stillschweigend ein
    // Ergebnis ohne die eingestellte Untergrenze.
    hasUsableTimeFilter() {
      return this.isUsableFilterDate(this.timeFilter.fromTime)
        && this.isUsableFilterDate(this.timeFilter.toTime);
    },
    setTimePicker(timeSpan) {
      this.showSpecificDateFilter = false;
      this.timeFilter = {
        fromTime: null,
        toTime: null,
      };
      this.setCurrentTimeSpan(timeSpan);
    },
    setCurrentTimeSpan(timeSpan) {
      this.currentTimeSpan = timeSpan;
      this.fetchPosts();
    },
    getCurrentTimeSpan() {
      // Nach "Konkreter Zeitraum" ist currentTimeSpan null, dann blieb time
      // undefined. In der Suche wurde daraus die Zeichenkette "undefined" im
      // Pfad; das Backend (ETSBackend/helpers/utils.js, getDateToCheck) prüft
      // nur auf time == undefined, die Zeichenkette fiel durch und
      // setDate(NaN) ergab ein ungültiges Datum — die Suche schlug fehl.
      // -1 steht für "Gesamt". Der Von-Bis-Filter greift dabei nur in
      // fetchPosts (POST mit fromTime/toTime), die Suchroute kennt ihn nicht.
      let time = -1;
      if(this.currentTimeSpan == 'Today') {
          time = 1;
      } else if (this.currentTimeSpan == 'LastWeek') {
          time = 7;
      } else if (this.currentTimeSpan == 'LastMonth') {
          time = 30;
      } else if (this.currentTimeSpan == 'AllTime') {
          time = -1;
      }

      return time;
    } 
  },
};
</script>

<style scoped>
.v-dialog > .v-card > .v-card__actions {
  padding: 8px 16px;
}

/* --- Tabelle ------------------------------------------------------------- */

.post-cell {
  display: flex;
  align-items: center;
}

/* Eckige Vorschau: auf einem runden Ausschnitt war vom Bild nichts zu sehen */
.post-preview {
  position: relative;
  width: 64px;
  height: 64px;
  flex: 0 0 64px;
  margin-right: 12px;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  background: rgba(148, 163, 184, 0.15);
}

.post-preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.post-preview-empty {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8f9bb3;
}

/* Marke für Beiträge mit mehreren Bildern — bisher war das nirgends zu sehen */
.post-image-count {
  position: absolute;
  top: 4px;
  right: 4px;
  min-width: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background: rgba(0, 0, 0, 0.65);
  color: #fff;
  font-size: 11px;
  line-height: 18px;
  text-align: center;
}

.post-description {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-width: 320px;
  white-space: normal;
}

.post-author {
  display: flex;
  align-items: center;
  white-space: nowrap;
}

/* Beide Schaltflächen bleiben nebeneinander — ohne feste Breite rutscht die
   zweite unter die erste, sobald die Beschreibung Platz beansprucht */
.post-actions {
  white-space: nowrap;
  width: 1%;
}

/* --- Bilderraster -------------------------------------------------------- */

.image-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
  gap: 10px;
  padding: 14px;
}

.image-tile {
  position: relative;
  aspect-ratio: 1 / 1;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  background: rgba(148, 163, 184, 0.15);
}

.image-tile img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.25s ease;
}

.image-tile:hover img {
  transform: scale(1.05);
}

.image-tile-empty {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8f9bb3;
  font-size: 24px;
}

/* Angaben erscheinen erst beim Überfahren, damit das Raster ruhig wirkt */
.image-tile-info {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 20px 10px 8px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  color: #fff;
  font-size: 12px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.75), transparent);
  opacity: 0;
  transition: opacity 0.2s ease;
}

.image-tile:hover .image-tile-info {
  opacity: 1;
}

.image-tile-author {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 8px;
}

.image-tile-stats {
  white-space: nowrap;
}

/* --- Großansicht --------------------------------------------------------- */

.gallery-view {
  background: #1a1d29;
  border-radius: 12px;
  overflow: hidden;
}

.gallery-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
}

.gallery-author {
  display: flex;
  align-items: center;
}

.gallery-close {
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  padding: 4px 8px;
}

.gallery-stage {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000;
  min-height: 320px;
  max-height: 68vh;
}

.gallery-image {
  max-width: 100%;
  max-height: 68vh;
  object-fit: contain;
}

.gallery-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  cursor: pointer;
  z-index: 2;
}

.gallery-arrow:hover {
  background: rgba(0, 0, 0, 0.75);
}

.gallery-arrow-left {
  left: 12px;
}

.gallery-arrow-right {
  right: 12px;
}

.gallery-foot {
  padding: 12px 16px;
}

.gallery-text {
  margin-bottom: 6px;
  word-break: break-word;
}

.gallery-meta {
  font-size: 12px;
  color: #8f9bb3;
}
</style>